module.exports = __webpack_public_path__ + "img/强大的全渠道信息化平台.27259fe7.png";